(function () {
  "use strict";

  function get(path) {
    return String(path || "").split(".").reduce(function (node, key) {
      return node && node[key];
    }, window.ODUREE_T || {});
  }

  window.odureeT = function (path, fallback) {
    var value = get(path);
    if (value === undefined || value === null || value === "") return fallback || "";
    return value;
  };
})();
